import React from 'react';
import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react';
type MetricCardProps = {
  label: string;
  value: string;
  change?: string;
  trend?: 'up' | 'down';
};
export function MetricCard({
  label,
  value,
  change,
  trend = 'up'
}: MetricCardProps) {
  return <article className="flex h-full min-h-[92px] flex-col justify-between rounded-lg border border-[#A6B6F8]/50 bg-white px-3.5 py-3" data-id="element-180" data-mp="kyl6v4b6p35v">
      <p className="text-[11px] font-semibold uppercase tracking-[0.1em] text-stone-500" data-id="element-181" data-mp="3ocnyg5ljqv3a">
        {label}
      </p>
      <div className="flex items-end justify-between gap-2" data-id="element-182" data-mp="3jffnaoytfrbj">
        <p className="text-xl font-bold tracking-tight text-[#041F60]" data-id="element-183" data-mp="25zh91qve8tq">
          {value}
        </p>
        {change && <span className={`flex items-center gap-1 text-[11px] font-semibold ${trend === 'up' ? 'text-[#5B5299]' : 'text-rose-600'}`} data-id="element-184" data-mp="3tcak93ffxjnp">
            {trend === 'up' ? <ArrowUpIcon size={12} data-id="element-185" data-mp="18n4gpo9vto02" /> : <ArrowDownIcon size={12} data-id="element-186" data-mp="18onwzevjfz1u" />}
            {change}
          </span>}
      </div>
    </article>;
}